
import Member_sdk from "./protocal/Member_sdk";
import ChatRoom from "./model/ChatRoom";
import Message from "./model/Message";
import axios from '../utils/axios.js'
import ProtocalType_S2C from "./protocal/ProtocalType_S2C";
import Customer from "./model/Customer";
import bus from '../utils/bus';
import MessageType from "./model/MessageType";
import common from "../utils/common";
const configTerminal  = {
    terminal_app : "APP",
    terminal_web : "WEB",
    terminal_wx : "WX",
};


const chatDataCenter =  {
    showChatPage:false,//是否打开聊天窗口
    loadPage:{
        requestLoad:false,
        initLoad:false,
    },
    chatTerminal:'',//聊天端
    vue:null,
    configTerminal:configTerminal,
    member_sdk:null,
    customer:null,
    chatRoom:new ChatRoom(),// 当前会话
    isLoadMessage:true,// 当前会话
    evaluation:{
        show:false, //请求打开评价窗口
        customerEvaluate:0, //是否已评价
        closeType:'6', //关闭会话类型：1客户主动关闭2客服主动3客户超时回复4客服超时回复5:邀请评价6：顾客主动评价
        sessionId:null,//会话id
    },
    notice:{
        show:true,
        noticeInfo:{
            title:''
        },
    },
    quickConsult: {
        chooseIndex: -1,
        list: [
            "发起借款",
            "借款状态查询",
            "如何还款",
            "30日内待还",
            "身份认证问题"
        ]
    },
    set:{
        isIFrame:true,
        windowSize:'',
        windowFlag:'1',//1:打开2：关闭
        tipSound:'1',
    },
    sessionSetInfo:null,
    linkInfo:{},
    hotLabelList:[],
    userSetInfo:null,
    channelInfo:null,
    robotInfo:null,
    leaveMessage:{
        show:false,
        sessionId:null
    },
    isOpenVerifyModal:false,//是否打开验证用户信息窗口
    labelListNew:[],//热点问题标签
    hotQuestionList:[],//热点问题列表
    bottomLabel:[],//底部标签列表

    isOpenFeedback:false,//是否打开意见反馈窗口
    isTransformDirectly:false,//是否是直接创建人工会话
    currentAnswerChatId:null,//操作答案的chatId
    customParams:{},//获取初始化传参
    showSkeleton:true,//是否展示骨架屏
    sidebarLabel: [], // 侧边栏标签
    sidebarProblem: [],  // 侧边栏问题
    wxJssdk:true,
    closeSession:function () {
        chatDataCenter.chatRoom.resetChatRoom();
        chatDataCenter.member_sdk.closeWebSocket();
    },
    quickEntryList:[],
    bottomLabelId:'',

    /**
     * 首次初始化在线客服所有数据
     */
    init:function (vue) {
        var _this = this;
        _this.vue = vue;
        _this.member_sdk = new Member_sdk({
            customerChannelId:chatDataCenter.customer.customerChannelId,
            vue:this.vue,
            /**
             * 物理连接回调函数
             * <p>
             * 建议:若用户当前停留在会话页面,且之前有loading效果,则去掉loading效果;否则,忽略
             */
            onConnect: function () {//
                console.log("物理连接创建成功...");
                chatDataCenter.initChatDataCenter(vue,function () {
                    chatDataCenter.loadPage.initLoad=false
                })
            },
            /**
             * 物理连接重连中回调函数
             * <p>
             * 建议:若用户当前停留在会话页面,则提示loading效果,当前物理连接已断开且正在重连中
             */
            onConnecting:function () {
                console.log("重连中...");
                chatDataCenter.reOpenChatDataCenter(vue,function () {
                    chatDataCenter.loadPage.initLoad=false
                })
            },
            /**
             * 与服务器断开物理连接回调函数
             * <p>
             * 建议:若用户当前停留在会话页面,则UI提醒用户;否则,忽略
             */
            onDisconnect: function () {
                console.log("与服务器断开连接...");
                vue.$messageBox.Confirm({
                    title:"确认提示",
                    message:'当前网络不稳定,确认重连?',
                    onClose:function () {
                        if(parent){
                            chatDataCenter.chatRoom.resetChatRoom();
                            parent.postMessage('deleteIframe', '*');
                            chatDataCenter.set.windowFlag='2'
                        }
                    },
                    onCancel:function () {
                        if(parent){
                            chatDataCenter.chatRoom.resetChatRoom();
                            parent.postMessage('deleteIframe', '*');
                            chatDataCenter.set.windowFlag='2'
                        }
                    },
                    onConfirm:function () {
                        // 网络重连
                        chatDataCenter.member_sdk.reConnect();
                    }
                });
            },
            /**
             * 物理连接被强制登出
             */
            onForceLoginOut:function () {
                console.log("异地登陆...");
                vue.$messageBox.NetworkConfirm({
                    message:'您已打开新的窗口,当前会话已断开',
                    onClose:function () {
                        if(parent){
                            chatDataCenter.chatRoom.resetChatRoom();
                            parent.postMessage('deleteIframe', '*');
                            chatDataCenter.set.windowFlag='2'
                        }
                    },
                    onCancel:function () {
                        if(parent){
                            chatDataCenter.chatRoom.resetChatRoom();
                            parent.postMessage('deleteIframe', '*');
                            chatDataCenter.set.windowFlag='2'
                        }
                    },
                    onConfirm:function () {
                        // 网络重连
                        chatDataCenter.member_sdk.reConnect();
                    }
                });
            },
            /**
             * 收到消息回调函数
             * @param message {Message}
             */
            onHandleProtoCal: function (protoCal) {
                if(typeof protoCal === 'undefined' || protoCal === null){
                    return;
                }
                var messageContent = JSON.parse(protoCal.messageContent);
                /**
                 * 消息分发
                 */
                switch (protoCal.msgType){
                    case ProtocalType_S2C.ACK:
                        //ACK应答包
                        chatDataCenter.member_sdk.handle_ACK(protoCal);
                        break;
                    case ProtocalType_S2C.S1:
                        //收到系统的消息(已入库)
                        chatDataCenter.chatRoom.receiveMessage(vue,new Message(messageContent));
                        break;
                    case ProtocalType_S2C.S3:
                        //收到系统的消息(未入库)
                        chatDataCenter.chatRoom.receiveMessage(vue,new Message(messageContent));
                        break;
                    case ProtocalType_S2C.M1_C:
                        if (messageContent.messageType=='R'&&chatDataCenter.channelInfo.overTimeFlag==1&&chatDataCenter.channelInfo.overTime!=null&&chatDataCenter.channelInfo.overTime!=0){
                            var time=0;
                            var robotFn = setInterval(function () {
                                time++
                                if(time>=chatDataCenter.channelInfo.overTime!=0){
                                    chatDataCenter.handleM1_C(vue,messageContent)
                                    clearTimeout(robotFn);
                                }
                            }, 1000);
                        }else {
                            chatDataCenter.handleM1_C(vue,messageContent)
                        }
                        break;
                    case ProtocalType_S2C.M2:
                        //通知顾客：无机器人或无效回答
                        if(chatDataCenter.chatRoom.sessionType==1&&chatDataCenter.chatRoom.queueFlag==0){
                            chatDataCenter.chatRoom.totalTimes= chatDataCenter.chatRoom.totalTimes+1
                            chatDataCenter.chatRoom.continuityTimes= chatDataCenter.chatRoom.continuityTimes+1
                            chatDataCenter.chatRoom.deleteMessage(new Message(messageContent));
                            //是否转人工
                            chatDataCenter.judgeTransferUser(_this.vue,true)
                        }
                        break;
                    case ProtocalType_S2C.N1_C:
                        //聊天消息状态变更通知
                        chatDataCenter.chatRoom.messageStatusChange(messageContent.messageId, messageContent.messageStatus)
                        break;
                    case ProtocalType_S2C.C1:
                        //关闭会话通知顾客--客服主动
                        chatDataCenter.closeSession()
                        chatDataCenter.evaluation.customerEvaluate=messageContent.customerEvaluate
                        chatDataCenter.evaluation.sessionId=messageContent.sessionId
                        chatDataCenter.evaluation.closeType='2'//客服主动
                        chatDataCenter.evaluation.show=true
                        break;
                    case ProtocalType_S2C.C1_CO:
                        //关闭会话通知顾客--客户超时回复
                        chatDataCenter.closeSession()
                        if(messageContent.sessionType==2){
                            chatDataCenter.evaluation.customerEvaluate=messageContent.customerEvaluate
                            chatDataCenter.evaluation.sessionId=messageContent.sessionId
                            chatDataCenter.evaluation.closeType='3'//客户超时回复
                            chatDataCenter.evaluation.show=true
                        }else {
                            chatDataCenter.evaluation.sessionId=null
                            chatDataCenter.evaluation.customerEvaluate=0
                            parent.postMessage('deleteIframe', '*');
                            chatDataCenter.set.windowFlag='2'
                        }
                        break;
                    case ProtocalType_S2C.C1_UO:
                        //关闭会话通知顾客--客服超时回复
                        chatDataCenter.closeSession()
                        chatDataCenter.evaluation.customerEvaluate=messageContent.customerEvaluate
                        chatDataCenter.evaluation.sessionId=messageContent.sessionId
                        chatDataCenter.evaluation.closeType='4'//客服超时回复
                        chatDataCenter.evaluation.show=true
                        break;
                    case ProtocalType_S2C.N3:
                        // 客服邀请您对服务进行评价
                        chatDataCenter.member_sdk.onHandleEvaluateInvitation(messageContent.sessionId);
                        break;
                    case ProtocalType_S2C.L2:
                        // 提醒顾客留言(系统发送给顾客)
                        chatDataCenter.member_sdk.onHandleLeaveMessageInvitation(messageContent.sessionId);
                        break;
                    case ProtocalType_S2C.T3:
                        //  接受转接通知顾客端变更会话ID
                        chatDataCenter.member_sdk.onHandleSessionChange(messageContent);
                        break;
                }
            },
            /**
             * 收到邀请评价回调函数
             * @param sessionId 会话ID 评价的时候需要带上sessionId
             * @param openEvaluateFlag 1:启用 2:禁用
             */
            onHandleEvaluateInvitation:function (sessionId) {
                if(chatDataCenter.chatRoom.sessionId==null||sessionId==chatDataCenter.chatRoom.sessionId){
                    chatDataCenter.evaluation.sessionId=sessionId
                    chatDataCenter.evaluation.closeType='5'//客服邀请评价
                    chatDataCenter.evaluation.show=true
                }else {
                    console.log("评价的会话非当前会话");
                }
            },

            /**
             * 收到邀请留言回调函数
             * @param sessionId 会话ID 留言的时候需要带上sessionId
             */
            onHandleLeaveMessageInvitation:function (sessionId) {
                if(chatDataCenter.chatRoom==null||chatDataCenter.chatRoom.sessionId==null){
                    console.log(" 留言无会话id");
                    chatDataCenter.leaveMessage.show=true
                    chatDataCenter.leaveMessage.sessionId=null

                }else {
                    if(sessionId==chatDataCenter.chatRoom.sessionId){
                        console.log("客服邀请您留言");
                        chatDataCenter.leaveMessage.show=true
                        chatDataCenter.leaveMessage.sessionId=sessionId
                    }else {
                        console.log("邀请留言的会话非当前会话");
                    }
                }

            },
            /**
             * 会话被客服关闭or会话超时被系统自动关闭
             */
            onHandleSessionBeClosed:function () {
                console.log("会话被关闭了");
            },

            /**
             * 消息被撤回
             * @param messageId 消息ID
             */
            onHandleMessageRecall:function (messageId) {

            },
            /**
             * 会话被动发生改变回调事件
             * @param obj
             */
            onHandleSessionChange:function (obj) {
                if( chatDataCenter.chatRoom.sessionType==2&&obj.sessionType==1){
                    chatDataCenter.chatRoom.welcomeFlag =true;
                }
                chatDataCenter.chatRoom.refreshChatRoom(obj,vue)
            },
        });
    },
    /**
     *
     * */
    initChatDataCenter:function (vue,callBack) {
        if (chatDataCenter.customer.customerChannelId==null){
            return;
        }
        console.log('初期化'+chatDataCenter.member_sdk.readyState)
        chatDataCenter.loadPage.initLoad=true
        // 获取会话信息
        chatDataCenter.getSessionInfo(function (sessionData) {
            var obj = sessionData.data;
            if(typeof obj !== 'undefined' && obj != null && typeof obj.sessionId !== 'undefined' && obj.sessionId != null && obj.sessionId !== ""){
                if(obj.sessionType=='2'){
                    chatDataCenter.getPersonalSetInfo(obj.userId,userInfo=> {
                        if(userInfo.code==0){
                            chatDataCenter.userSetInfo=userInfo.data;
                        }else{
                            console.log("查询客服设置信息");
                        }
                    });
                }
                chatDataCenter.chatRoom.refreshChatRoom(obj,vue);
                if(callBack){
                    callBack();
                }
                // 加载历史消息
                chatDataCenter.chatRoom.loadHistoryMessages(vue,obj.sessionId,messageData=>{
                    if(messageData.code==0){
                        chatDataCenter.chatRoom.readMessages()
                        chatDataCenter.scrollToBottom("2")
                        //2020.02.14 如果会话为机器人会话，在加载欢迎语
                        if(obj.sessionType=='1'){
                            chatDataCenter.chatRoom.welcomeFlag =true;
                            chatDataCenter.pushHotPoint();
                        }
                    }else{
                        console.log("加载历史消息发生异常");
                    }
                })
            }else{
                chatDataCenter.chatRoom.resetChatRoom();
                chatDataCenter.getRobotClose( robotClose=> {
                    chatDataCenter.createSession(vue,robotClose,function () {
                        if(callBack){
                            callBack();
                        }
                    })
                });
            }
        });
    },

    /**
     * */
    reOpenChatDataCenter:function (vue,callBack) {
        if (chatDataCenter.customer.customerChannelId==null){
            return;
        }
        console.log('重连'+chatDataCenter.member_sdk.readyState)
        chatDataCenter.loadPage.initLoad=true
        // 获取会话信息
        chatDataCenter.getSessionInfo(function (sessionData) {
            var obj = sessionData.data;
            if(typeof obj !== 'undefined' && obj != null && typeof obj.sessionId !== 'undefined' && obj.sessionId != null && obj.sessionId !== ""){
                if(obj.sessionType=='2'){
                    chatDataCenter.getPersonalSetInfo(obj.userId,function (userInfo) {
                        if(userInfo.code==0){
                            chatDataCenter.userSetInfo=userInfo.data;
                        }else{
                            console.log("查询客服设置信息");
                        }
                    });
                }
                chatDataCenter.chatRoom.refreshChatRoom(obj,vue);
                if(callBack){
                    callBack();
                }
                // 加载历史消息
                chatDataCenter.chatRoom.loadHistoryMessages(vue,obj.sessionId,function (messageData) {
                    if(messageData.code==0){
                        chatDataCenter.chatRoom.readMessages()
                        chatDataCenter.scrollToBottom("2")
                    }else{
                        console.log("加载历史消息发生异常");
                    }
                })
            }else{
                chatDataCenter.chatRoom.resetChatRoom();
            }
        });
    },
    /**
     * 初期化
     */
    _initInfo_:function(vue){
        if(chatDataCenter.customer&&chatDataCenter.customer.sourceChannelId){
            //公告信息
            chatDataCenter.getNoticeByChannelId(function (responseNotice) {
                if (responseNotice.code==0&&responseNotice.data!=null) {
                    chatDataCenter.notice.noticeInfo=responseNotice.data
                }
            })
            if (chatDataCenter.channelInfo.recepteRobotId){
                chatDataCenter.getRobotById(chatDataCenter.channelInfo.recepteRobotId,function (recepteRes) {
                    if(recepteRes.code==0){
											chatDataCenter.robotInfo=recepteRes.data;
											if(common.isWx()){
												let url = window.location.href.split("#")[0];
												chatDataCenter.fetchWeiXinConfig(url,chatDataCenter.linkInfo.thirdId);
											};
											chatDataCenter.getLabel();
											chatDataCenter.getQuickEntryList();
											chatDataCenter.getBottomList();
											if(recepteRes.data.sideShow){
													chatDataCenter.getSidebarTagList()
											}
                    }else {
                        chatDataCenter.robotInfo=null;
                    }
                })
            }
            //加载会话设置
            chatDataCenter.getSetSessionByCompanyId(vue,function () {
                chatDataCenter.showChatPage=true
                chatDataCenter.init(vue);
            })

        }else {
            vue.$messageBox.Error({message:"无此顾客",duration:3000});
        }
    },

    /**
     * 【START】根据ID查询接入设置
     */
    getLinkByThirdId : function (thirdId,callback) {
        axios.post('setLink/getLinkByThirdId', {thirdId:thirdId}, response => {
            if(callback){
                callback(response);
            }
        });
    },

    /***
     *  【START】获取顾客信息
     * */
    getCustomerIdByCustomerChannelId:function (customerChannelId,callback) {
        axios.post('/customer/getCustomerIdByCustomerChannelId',{ customerChannelId:customerChannelId},function(data){
            if(callback){
                callback(data);
            }
        });
    },

    /***
     *  【START】获取顾客信息
     * */
    getCustomerById:function (customerId,callback) {
        axios.post('/customer/getCustomerById',{ customerId:customerId},function(data){
            if(callback){
                callback(data);
            }
        });
    },

    /**
     * 【START】创建顾客
     * @param param
     * @param callback
     */
    createCustomer:function (param, callback) {
        axios.post('/customer/createCustomer',param,function(data){
            if(callback){
                callback(data);
            }
        });
    },

    setCustomer:function (vue,thirdId,customer,customerChannel,callback) {
        customer.thirdId=thirdId
        customer.customerChannelId=customerChannel.customerChannelId
        customer.sourceChannelId=customerChannel.channelId
        customer.robotInitInfo=customerChannel.robotInitInfo
        if(customer.avatar==undefined||customer.avatar==null||customer.avatar==''){
            if (chatDataCenter.linkInfo){
                customer.avatar=chatDataCenter.linkInfo.userAvator
            }
        }
        chatDataCenter.customer = new Customer(customer)
        localStorage.setItem("customerCodePage",customer.customerCode);
        if (callback){
            callback(chatDataCenter.customer)
        }
    },
    createCustomerByPage:function (vue,to,curVal,companyId,thirdId,channelId, callback) {
       if(curVal.customerChannelId){
            chatDataCenter.getCustomerIdByCustomerChannelId(curVal.customerChannelId,function (customerChannel) {
                if(customerChannel.code==0){
                    if(customerChannel.data!=null){
                        chatDataCenter.getCustomerById(customerChannel.data.customerId,function (data) {
                            if(data.code==0&&data.data){
                               chatDataCenter.setCustomer(vue,thirdId,data.data,customerChannel.data,callback)
                            }else {
                                if (vue){
                                    vue.$messageBox.Error({message:'获得顾客信息失败',duration:3000});
                                }else {
                                    console.error('获得顾客信息失败')
                                }
                            }
                        })
                    }
                }else {
                    if (vue){
                        vue.$messageBox.Error({message:'获得顾客渠道信息失败',duration:3000});
                    }else {
                        console.error('获得顾客渠道信息失败')
                    }
                }
            })
        }else {
            var userName="";
            if(curVal.userName!=undefined &&curVal.userName != null && curVal.userName != ''){
                userName=curVal.userName;
            }

            var nickName="";
            if(curVal.nickName!=undefined &&curVal.nickName != null && curVal.nickName != ''){
                nickName=curVal.nickName;
            }

            var name="";
            if(curVal.name!=undefined &&curVal.name != null && curVal.name != ''){
                name=curVal.name;
            }

            var tel="";
            if(curVal.tel!=undefined &&curVal.tel != null && curVal.tel != ''){
                tel=curVal.tel;
            }
           chatDataCenter.getCustomerCode(to,curVal,customerCode=>{
               if (customerCode){
                   var param={
                       companyId:companyId,
                       customerCode:customerCode,
                       nickName:userName ? userName : nickName,
                       name:userName ? userName : name,
                       tel:tel,
                       channelId:channelId
                   }
                   chatDataCenter.createCustomer(param, function (data) {
                       if(data.code==0&&data.data){
                           chatDataCenter.getCustomerIdByCustomerChannelId(data.data.customerChannelId,function (customerChannel) {
                               if(customerChannel.code==0&&customerChannel.data!=null){
                                   chatDataCenter.setCustomer(vue,thirdId,data.data,customerChannel.data,callback)
                               }else {
                                   if (vue){
                                       vue.$messageBox.Error({message:'获得顾客渠道信息失败',duration:3000});
                                   }else {
                                       console.error('获得顾客渠道信息失败')
                                   }
                               }
                           })
                       }else {
                           if (vue){
                               vue.$messageBox.Error({message:'创建顾客信息失败',duration:3000});
                           }else {
                               console.error('创建顾客信息失败')
                           }
                       }
                   });
               }
           })
        }
    },

    getCustomerCode:function ( to,curVal,callback) {
        var customerCode="";
        //判断js调用咨询窗时 有没有传入userId
        if(curVal.customerCode!=undefined &&curVal.customerCode != null && curVal.customerCode != ''){
            customerCode=curVal.customerCode;
        }
        //判断网址接入时 有没有传入userId
        if(curVal.userId){
            customerCode=curVal.userId;
        }
        if(!customerCode){
            //判断是否有存储
            const customerCodePage = localStorage.getItem("customerCodePage");
            if(customerCodePage){//存在 则取存储
                customerCode = customerCodePage;
            }else {//不存在 则取当前时间的时间戳
                customerCode = new Date().getTime().toString()
            }
        }
        localStorage.setItem("customerCodePage",customerCode);
        callback(customerCode)
    },

    /**
     * 【START】加载会话设置
     */
    getSetSessionByCompanyId : function (vue,callback) {
        axios.post('setSession/querySetSessionInfo', {companyId:chatDataCenter.customer.companyId}, response => {
            if (response.code==0) {
                chatDataCenter.sessionSetInfo = response.data;
                if(callback){
                    callback();
                }
            }else{
                vue.$messageBox.Error({message:response.msg,duration:3000});
            }
        });
    },

    /**
     * 【START】获取渠道信息
     * @param callback
     */
    getChannelInfo:function (channelId, callback) {
        axios.post('/channel/getChannelByChannelId',{
            channelId:channelId
        },function(data){
            if(callback){
                callback(data);
            }
        });
    },

    /**
     *  【START】根据ID查询机器人
     * @param callback
     */
    getRobotById:function (robotId, callback) {
        if(robotId==null||robotId==''){
            callback({ message:"不存在机器人",code:1});
        }else {
            axios.post('/setRobot/getRobotById',{
                robotId:robotId
            },function(data){
                if(callback){
                    callback(data);
                }
            });
        }

    },

    /**
     * 【START】查询顾客会话信息
     * @param callback
     */
    getSessionInfo:function (callback) {
        axios.post('/chatCustomer/getOnlineSessionByCustomerChannelId',{
            customerChannelId:chatDataCenter.customer.customerChannelId,
            thirdId:chatDataCenter.customer.thirdId
        },function(data){
            if (data.code == 0) {
                if(callback){
                    callback(data);
                }
            } else {
                console.log(" 查询顾客会话信息失败")
            }
        });
    },

    /**
     * 【START】客服机器人开关
     * */
    getRobotClose:function (callBack) {
        if(chatDataCenter.robotInfo==null){
            if(callBack){
                callBack(2);
            }
        }else {
            axios.post('/channel/getRobotClose',{
                channelId:chatDataCenter.channelInfo.channelId
            }, function (res) {
                if (res.code == 0) {
                    if(callBack){
                        callBack(res.data==3?1:res.data);
                    }
                }else {
                    console.log("获得接待方式失败")
                }

            });
        }

    },

    /**
     * 【START】创建会话（机器人或人工）
     */
    createSession:function (vue,robotClose,callBack) {
        var _this = this;
        if (robotClose==1){
            //手动开关--客服机器人启动
            chatDataCenter.createRobotSession(vue,function () {
                if(callBack){
                    callBack();
                }
            })
        }
        if (robotClose==2){
            //手动开关--客服机器人关闭
            if (chatDataCenter.channelInfo.consultFlag==1){
                _this.getConsultTypeList(chatDataCenter.customer.sourceChannelId,function (data) {
                    if (data.code==0){
                        _this.notifyMessage('U','Z',JSON.stringify(data.data))
                        if(callBack){
                            callBack();
                        }
                    }
                });
            }else {
                _this.createStaffSession(vue,2,null,'/chatCustomer/createArtificialSession',function () {
                    if(callBack){
                        callBack();
                    }
                });
            }
        }
    },

    /**
     * 【START-点击咨询类型】创建人工会话
     */
    createStaffSession:function (vue,type,consultId,url,callBack) {
        if (url.indexOf('transferArtificial')>-1&&(chatDataCenter.chatRoom==null||chatDataCenter.chatRoom.id==null||chatDataCenter.chatRoom.sessionId==null)){
            chatDataCenter.notifyMessage('S','S3','当前无会话，请刷新页面后再操作或#重新接入#')
            return;
        }
        if (chatDataCenter.chatRoom.sessionType=='2'&&chatDataCenter.chatRoom.userId!=null){
            chatDataCenter.notifyMessage('S','S3','正在人工会话中')
            return;
        }
        if (chatDataCenter.chatRoom.queueFlag!=0){
            chatDataCenter.selectQueueNumByCustomer(1,function () {})
            // chatDataCenter.notifyMessage('S','S3','正在排队中，输入#人数#，查看当前排队人数')
            return;
        }
        var customerInfo = chatDataCenter.customer.getCustomer();
        customerInfo.type=type//是否自动转人工,1自动2主动
        if (consultId!=undefined&&consultId!=null){
            customerInfo.consultId=consultId
        }
        if(customerInfo.avatar==null||customerInfo.avatar==''){
            customerInfo.avatar=chatDataCenter.linkInfo.userAvator
        }
        if (url.indexOf('transferArtificial')>-1){
            chatDataCenter.apiAskingForHuman()
        }
        axios.post(url,customerInfo, function (res) {
            if (res.code == 0) {
                if(res.data != null){
                    if(chatDataCenter.chatRoom.sessionId==res.data.sessionId){
                        if (res.data.sessionType==1&&res.data.queueFlag==0){
                            console.log("未分配成功");
                        }
                        if(res.data.queueFlag!=0&&res.data.sessionType!=2){
                            console.log("排队中");
                        }
                        if (res.data.sessionType==2){
                            if(res.data.queueFlag!=0){
                                console.log("排队中");
                            }
                            chatDataCenter.getPersonalSetInfo(res.data.userId,function (userInfo) {
                                if(userInfo.code==0){
                                    chatDataCenter.userSetInfo=userInfo.data;
                                }else{
                                    console.log("查询客服设置信息");
                                }
                            });
                        }
                    }else if (chatDataCenter.chatRoom.id!=null){
                        chatDataCenter.chatRoom.refreshChatRoom(res.data,vue)
                    }
                }
            } else {
                console.log("转人工会话接口異常")
            }
            if(callBack){
                callBack();
            }
        });
    },

    /**
     * 【调用】创建机器人会话
     */
    createRobotSession:function (vue,callback) {
        var customerInfo = chatDataCenter.customer.getCustomer();
        if(customerInfo.avatar==null||customerInfo.avatar==''){
            customerInfo.avatar=chatDataCenter.linkInfo.userAvator
        }
        axios.post('/chatCustomer/createRobotSession',customerInfo, function (res) {
            if (res.code == 0) {
                console.log("机器人会话创建成功");
                chatDataCenter.chatRoom.welcomeFlag =true;
                chatDataCenter.chatRoom.refreshChatRoom(res.data,vue)
                if(callback){
                    callback();
                }
            } else {
                console.log("机器人会话创建失败");
            }
        });
    },

    /**
     * 【ING】点击转人工会话
     */
    transferStaffSession:function (vue,type) {
        var _this = this;
        if (chatDataCenter.chatRoom==null||chatDataCenter.chatRoom.id==null||chatDataCenter.chatRoom.sessionId==null){
            chatDataCenter.notifyMessage('S','S3','当前无会话，请刷新页面后再操作或#重新接入#')
            return ;
        }
        if (chatDataCenter.chatRoom.sessionType=='2'&&chatDataCenter.chatRoom.userId!=null){
            chatDataCenter.notifyMessage('S','S3','正在人工会话中')
            return;
        }
        if (chatDataCenter.chatRoom.queueFlag!=0){
            chatDataCenter.selectQueueNumByCustomer(1,function () {})
            // chatDataCenter.notifyMessage('S','S3','正在排队中，输入#人数#，查看当前排队人数')
            return;
        }
        if (_this.channelInfo!=null){
            if (_this.channelInfo.consultFlag==1){
                _this.getConsultTypeList(chatDataCenter.customer.sourceChannelId,function (data) {
                    if (data.code==0){
                        _this.notifyMessage('U','Z',JSON.stringify(data.data))
                    }
                });
            }else {
                _this.createStaffSession(vue,type,null,'/chatCustomer/transferArtificial',function () {

                });
            }
        }
    },

    /***
     *  【ING】处理收到的消息
     * */
    handleM1_C:function (vue,messageContent) {
        chatDataCenter.chatRoom.receiveMessage(vue,new Message(messageContent));
        //通知顾客：日常咨询消息(相互发送)
        if (messageContent.messageType=='R'){
            chatDataCenter.chatRoom.changeTimes= false;

            var containsFlag=false;
            if(chatDataCenter.chatRoom.sessionType==1&&chatDataCenter.chatRoom.queueFlag==0){
                if (chatDataCenter.isJSON(messageContent.messageContent)) {
                    if ((JSON.parse(messageContent.messageContent).semantic_id
                            &&'NOT_FOUND'==JSON.parse(messageContent.messageContent).semantic_id)) {
                        chatDataCenter.chatRoom.totalTimes = chatDataCenter.chatRoom.totalTimes + 1
                        chatDataCenter.chatRoom.continuityTimes = chatDataCenter.chatRoom.continuityTimes + 1
                        chatDataCenter.chatRoom.changeTimes = true;
                        containsFlag=true;
                    } else {
                        if (chatDataCenter.chatRoom.continuityTimes != 0) {
                            chatDataCenter.chatRoom.changeTimes = true;
                            chatDataCenter.chatRoom.continuityTimes = 0
                        }
                    }
                } else {
                    if (chatDataCenter.chatRoom.continuityTimes != 0) {
                        chatDataCenter.chatRoom.changeTimes = true;
                        chatDataCenter.chatRoom.continuityTimes = 0
                    }
                }
            }
            //是否转人工
            chatDataCenter.judgeTransferUser(vue,containsFlag)
        }
    },

    /***
     *  【ING】判断自动转人工
     * */
    judgeTransferUser:function (vue,containsFlag) {
        if(chatDataCenter.chatRoom.changeTimes&&chatDataCenter.chatRoom.sessionType==1&&chatDataCenter.chatRoom.queueFlag==0){
            axios.post('/chatCustomer/refreshRobotTimes', {
                customerChannelId:chatDataCenter.customer.customerChannelId,
                totalTimes:chatDataCenter.chatRoom.totalTimes,
                continuityTimes:chatDataCenter.chatRoom.continuityTimes
            }, function(data){
                if(data.code==0){
                    // console.log("修改机器人回答不了的次数成功")
                }else {
                    console.log("修改机器人回答不了的次数失败")
                }
            });
        }
        if(chatDataCenter.sessionSetInfo!=null&&chatDataCenter.chatRoom.sessionType==1&&chatDataCenter.chatRoom.queueFlag==0){
            var times=0
            if (chatDataCenter.sessionSetInfo.transferFlag==1){ //会话转接确认(1连续2累计)
                times=chatDataCenter.chatRoom.continuityTimes
            }
            if (chatDataCenter.sessionSetInfo.transferFlag==2){
                times=chatDataCenter.chatRoom.totalTimes
            }
            if(times>chatDataCenter.sessionSetInfo.transferTimes){
                if(chatDataCenter.sessionSetInfo.transferAuto==1){//是否自动转人工（1是2不自动）
                    this.transferStaffSession(vue,1)
                }else {
                    //提示信息
                    if (containsFlag){
                        this.notifyMessage('S','S1','由于多次无法回答您的问题,您可以输入#转人工#')
                    }
                }
            }
        }
    },

    /**
     * 【ING】查询客服设置信息
     */
    getPersonalSetInfo : function (userId,callback) {
        if(userId){
            axios.post('personalSet/getPersonalSetInfo', {userId:userId}, response => {
                if(callback){
                    callback(response);
                }
            });
        }
    },

    /**
     * 【ING】获取咨询问题类型
     * @param callback
     */
    getConsultTypeList:function (channelId, callback) {
        axios.post('/channel/getChannelConsultTypeById',{
            channelId:channelId
        },function(data){
            if(callback){
                callback(data);
            }
        });
    },
    /**
     * 【ING】获取留言咨询问题类型
     * @param callback
     */
    getConsultTypeLeaveList:function (channelId, callback) {
        axios.post('/channel/getChannelConsultTypeLeaveById',{
            channelId:channelId
        },function(data){
            if(callback){
                callback(data);
            }
        });
    },

    /**
     * 【ING】顾客主动关闭会话
     */
    closeSessionByCustomer:function (callback) {
        axios.post('/chatCustomer/closeSessionByCustomer',{customerChannelId:chatDataCenter.customer.customerChannelId},function(data){
            if(callback){
                callback(data);
            }
        });
    },

    /**
     * 【ING】加载评价设置
     */
    getEvaluateByCompanyId : function (vue,callback) {
        axios.post('setEvaluate/getEvaluateByCompanyId', {companyId:chatDataCenter.customer.companyId}, response => {
            if(callback){
                callback(response);
            }
        });
    },

    /**
     *  【ING】根据渠道ID查询通知公告
     */
    getNoticeByChannelId : function (callback) {
        axios.post('setNotice/getNoticeByChannelId', {channelId:chatDataCenter.customer.sourceChannelId}, response => {
            if(callback){
                callback(response);
            }
        });
    },
    /**
     *  【ING】查询当前排队
     */
    selectQueueNumByCustomer : function (searchFlag,callback) {
        axios.post('chatCustomer/selectQueueNumByCustomer', {
            customerChannelId:chatDataCenter.customer.customerChannelId,
            searchFlag:searchFlag
        }, response => {
            if(callback){
                callback(response);
            }
        });
    },

    /**
     * 【ING】给这个会话发送消息(发送指定内容)
     * @param index
     */
    sendMessageByContent:function (content,questionSource) {
        if(typeof content == 'undefined' || content == null || content == ''){
            console.error("content can't be null");
            return;
        }
        if (this.chatRoom.sessionId!=null){
            this.chatRoom.sendMessageByContent(content,questionSource);
        }
    },
    sendMessageJudge:function (vue,text,callback) {
        if((chatDataCenter.chatRoom==null||chatDataCenter.chatRoom.sessionId==null)){
            if(text!='#重新接入#'){
                chatDataCenter.notifyMessage('S','S3','当前无会话，请刷新页面后再操作或#重新接入#')
                return ;
            }else {
                chatDataCenter.initChatDataCenter(vue,function () {
                    chatDataCenter.loadPage.initLoad=false
                    chatDataCenter.set.windowFlag='1'
                    if(chatDataCenter.member_sdk==null||chatDataCenter.member_sdk.readyState !== WebSocket.OPEN){
                        chatDataCenter.init(vue);
                    }else{
                        chatDataCenter.member_sdk.reConnect();
                    }
                    return ;
                })
            }
        }
        if((chatDataCenter.chatRoom.sessionType==2&&chatDataCenter.chatRoom.userId==null)){
            if(chatDataCenter.chatRoom.queueFlag==0){ //非排队
                chatDataCenter.notifyMessage('S','S3','请先转人工')
                return;
            }
            if(chatDataCenter.chatRoom.queueFlag!=0){
                chatDataCenter.selectQueueNumByCustomer(1,function () {})
                // chatDataCenter.notifyMessage('S','S3','正在排队中，输入#人数#，查看当前排队人数')
                return;
            }
        }
        if(callback){
            callback()
        }
    },

    /***
     *  【ING】通知消息
     * */
    notifyMessage:function (messageDirection,messageType,messageContent) {
        if(messageContent==null||messageContent==''){
            return false;
        }
        if(MessageType.L==messageType&&chatDataCenter.chatRoom.sessionType!=1){
            return false;
        }
        var message=new Message({
            messageId :null,
            sessionId :chatDataCenter.chatRoom.sessionId,
            customerId :chatDataCenter.chatRoom.customerId,
            customerChannelId :chatDataCenter.chatRoom.customerChannelId,
            messageDirection :messageDirection, //C:顾客发给客服；U客服发给顾客，S系统
            messageType :messageType, //T:文本 I:图片 V:视频 F:文件 S1:系统消息(发送给顾客) S2:系统消息(发送给客服) R:机器人回复消息
            messageStatus :0,//-1:发送失败0:发送中10:未读 20:已读 30:离线:40撤回
            messageContent :messageContent,
            receiveId :chatDataCenter.chatRoom.customerChannelId,
            senderCode :"",
            senderNickname :chatDataCenter.linkInfo.artificialName,
            sendTime :new Date().getTime(),//发送时间
        })
        chatDataCenter.chatRoom.messages.push(message)
        chatDataCenter.scrollToBottom("1");
        chatDataCenter.audioPlayer()
    },

    /**
     * 【ING】滚动
     */
    scrollToBottom: function (type) {
        if(chatDataCenter.chatTerminal=='WEB'){
            bus.$emit("scrollToBottomWeb",type);
        }else {
            bus.$emit("scrollToBottomApp",type);
        }
    },
    /**
     * 【ING】新消息提示音
     */
    audioPlayer:function () {
        if(chatDataCenter.chatRoom.sessionType=='2'||
            (chatDataCenter.chatRoom.sessionType=='3'&&chatDataCenter.chatRoom.beforeType=='2')){
            if(chatDataCenter.set.tipSound=='1'){
                bus.$emit("audioPlay",'');
            }
        }
    },
    /**
     * 【ING】机器人回答是否解决
     */
    apiEvaluateRobotAnswer:function (solveStatus,channel,index,item) {
        if (item.messageType=='R'&&item.bindId!=null){
            try {
                var chatId=  JSON.parse(item.messageContent).chatId;
                axios.getCloud('/cloud/custom/evaluation',{
                    chatId:chatId,
                    channel:channel,
                    robotId:item.bindId,
                    isResolved:solveStatus=='2'?true:false
                }, function (res) {
                    if (res.success) {
                        chatDataCenter.chatRoom.messages[index].solveStatus=solveStatus
                    }
                });
            } catch(e) {
            }
        }
    },

    /**
     * 【ING】上一条转人工话术
     */
    apiAskingForHuman:function () {
        axios.getCloudJsonp('/cloud/service/askingForHumanService',{
            channel:'web',
            robotId:chatDataCenter.robotInfo.bindId,
            userId:chatDataCenter.chatRoom.customerChannelId,
            sessionId:chatDataCenter.chatRoom.sessionId,
        }, function (res) {

        });
    },

    /**
     *  【ING】获取欢迎语
     */
    getWelcome : function (sessionId,callback) {
        axios.post('chatCustomer/getWelcome', {
            sessionId:sessionId
        }, response => {
            if(callback){
                callback(response);
            }
        });
    },

    getHotLabelList: function () {
        console.log("getHotLabelList:"+chatDataCenter.robotInfo.bindId)
        //"1281767038230073344"
        axios.getCloud("/hotQa/label/listWeb",  {robotId: chatDataCenter.robotInfo.bindId} , function (res) {
            if (res.data){
                chatDataCenter.hotLabelList = res.data.data;
            }
        });
    },

    getHotList: function (hotLabelId,callback) {
        let params = {
            robotId: chatDataCenter.robotInfo.bindId,
            hotLabelId: hotLabelId,
            type:'pc'
        }
        axios.getCloud("/hotQa/qa/listWeb",  params, function (response) {
            chatDataCenter.labelListNew = res.data.data;
            if(callback){
                callback(response);
            }
        });
    },
    /**
     * 【ING】机器人初始化接口
     */
    apiInitRobot:function (welcomeFlag) {
      var params={
        robotId:chatDataCenter.robotInfo.bindId,
        userId:chatDataCenter.customParams.userId,
        sessionId:chatDataCenter.chatRoom.sessionId,
        userName:chatDataCenter.customParams.userName ? chatDataCenter.customParams.userName : chatDataCenter.customParams.userId
      }
      console.log('初始化参数======',chatDataCenter.customParams)

      //设置initData参数
      var initData=chatDataCenter.customParams.initData;
      if(initData!=undefined&&initData!=null&&initData!=''){
        try {
          initData=JSON.parse(chatDataCenter.customParams.initData)
        }catch (e){
          initData={}
        }
      }else {
        initData={}
      }
      initData.userId = params.userId;
      initData.userName = params.userName;
      //设置&拼接的参数
      var otherParams = chatDataCenter.customParams.otherParams;
      if(otherParams.thirdId){
        delete otherParams.thirdId;
      }
      if(otherParams.userId){
        delete otherParams.userId;
      }
      if(otherParams.userName){
        delete otherParams.userName;
      }
      if(otherParams.initData){
        delete otherParams.initData;
      }
      if(otherParams.customerChannelId){
        delete otherParams.customerChannelId
      }
      if(otherParams.frame){
        delete otherParams.frame
      }
      if(otherParams.channelId){
        delete otherParams.channelId
      }
      if(otherParams.companyId){
        delete otherParams.companyId
      }

      let assignObj = Object.assign(initData,otherParams);
      for (let item in assignObj){
        if(!item){
          delete assignObj[item]
        }
      }
      params.initData=assignObj
      chatDataCenter.paramsInitData = assignObj;

      axios.postApi('/api/robot/session/init/'+chatDataCenter.chatRoom.sessionId,params, function (res) {
        console.log("机器人初始化"+res.success)
        if(welcomeFlag){
          chatDataCenter.getWelcome(params.sessionId,function (data) {
            chatDataCenter.chatRoom.welcomeFlag =false;
          })
        }
      });
    },

    /**
     * 【ING】点击系统消息中的按钮
     */
    clickEvent:function (name,vue) {
        if (name=='#人数#'){
            chatDataCenter.selectQueueNumByCustomer(2,function () {})
        }
        if (name=='#留言#'){
            chatDataCenter.leaveMessage.show=true
        }
        if (name=='#客服名称#'&&chatDataCenter.chatRoom.sessionType=='2'){
            var artificialName=chatDataCenter.linkInfo.artificialName;
            if (artificialName!=undefined){
                if (chatDataCenter.userSetInfo!=null&&chatDataCenter.userSetInfo.nickname!=null
                    &&chatDataCenter.userSetInfo.nickname!=''){
                    artificialName=chatDataCenter.userSetInfo.nickname;
                }
                var content='客服#客服名称#正在为您服务..'.replace('#客服名称#',artificialName)
                chatDataCenter.notifyMessage('S','S3',content)
            }
        }
        if (name=='#重新接入#'){
            if(chatDataCenter.chatRoom!=null&&chatDataCenter.chatRoom.id!=null&&chatDataCenter.chatRoom.sessionId!=null){
                chatDataCenter.notifyMessage('S','S3','当前正在会话，无需重新接入')
            }else {
                chatDataCenter.set.windowFlag='1'
                if(chatDataCenter.member_sdk==null){
                    chatDataCenter.init(vue);
                }else{
                    if(chatDataCenter.member_sdk.readyState === WebSocket.OPEN){
                        chatDataCenter.initChatDataCenter(vue,function () {
                            chatDataCenter.loadPage.initLoad=false
                        })
                    }else {
                        chatDataCenter.member_sdk.reConnect();
                    }
                }
            }
        }
    },

    /**
     * 【ING】转JSON
     */
    isJSON: function(str ) {
        if (typeof str == 'string') {
            try {
                var obj=JSON.parse(str);
                if(typeof obj == 'object' && obj ){
                    return true;
                }else{
                    return false;
                }

            } catch(e) {
                return false;
            }
        }
        return false;
    },

  /**
   * 根据robotId获取热点问题标签
   */
  getLabel: function () {
    console.log(chatDataCenter.robotInfo.robotId)
    console.log('======',chatDataCenter.customParams)
    axios.getCloud(
      "/cloud/hotQa/label/listWeb",
      { robotId: chatDataCenter.robotInfo.bindId,userType:chatDataCenter.customParams.otherParams.USER_TYPE ? chatDataCenter.customParams.otherParams.USER_TYPE : '' },
      function (res) {
        console.log(res)
        if(res.success){
          let data = res.data.data;
          //判断是否有底部标签 有 获取底部标签下的所有标签
          let arr = data.filter((item) => {
            return item.type == 1;
          });
          if(arr.length > 0){
            chatDataCenter.getHotQuestion(arr[0],'bottomLabel');
          }

          //取出所有自定义标签 若至少有一个 则获取第一个自定义标签下的关联问题
          let arrHot = data.filter(item => item.type === 0);
          if (arrHot.length > 0) {
            chatDataCenter.getHotQuestion(arrHot[0]);
          }
          chatDataCenter.labelListNew =arrHot;
        }

      }
    );
  },

  /**
   * 根据标签获取标签下的关联问题
   */
  getHotQuestion: function (data,type) {
    let params = {
      robotId: chatDataCenter.robotInfo.bindId,
      hotLabelId: data.id,
    };
    axios.postCloud("/cloud/hotQa/qa/listWeb", params, (response) => {
      console.log(response)
      if(response.success){
        if(type && type === 'bottomLabel'){
          chatDataCenter.bottomLabel = response.data.data;
        }else {
          chatDataCenter.hotQuestionList = response.data.data;
        }
      }
    });
  },

  /**
   * 推送热点问题
   */
  pushHotPoint: function () {
    var messageHotLabel = new Message({
      messageId: null,
      sessionId: chatDataCenter.chatRoom.sessionId,
      customerId: chatDataCenter.chatRoom.customerId,
      customerChannelId: chatDataCenter.chatRoom.customerChannelId,
      messageDirection: "U", //C:顾客发给客服；U客服发给顾客，S系统
      messageType: "H", //T:文本 I:图片 V:视频 F:文件 S1:系统消息(发送给顾客) S2:系统消息(发送给客服) R:机器人回复消息 H:展示热点问题标签
      messageStatus: 10, //-1:发送失败0:发送中10:未读 20:已读 30:离线:40撤回
      messageContent: "",
      receiveId: chatDataCenter.chatRoom.customerChannelId,
      senderCode: "",
      senderNickname: chatDataCenter.linkInfo.artificialName,
      sendTime: new Date().getTime(), //发送时间
    });
    setTimeout(() => {
      chatDataCenter.chatRoom.messages.push(messageHotLabel);
      chatDataCenter.scrollToBottom("2");
    }, 400);
  },

  /**
   * 模拟机器人向用户推送消息
   */
  pushMessage:function (content) {
    var messageHotLabel = new Message({
      messageId: null,
      sessionId: chatDataCenter.chatRoom.sessionId,
      customerId: chatDataCenter.chatRoom.customerId,
      customerChannelId: chatDataCenter.chatRoom.customerChannelId,
      messageDirection: "U", //C:顾客发给客服；U客服发给顾客，S系统
      messageType: "R", //T:文本 I:图片 V:视频 F:文件 S1:系统消息(发送给顾客) S2:系统消息(发送给客服) R:机器人回复消息 H:展示热点问题标签
      messageStatus: 20, //-1:发送失败0:发送中10:未读 20:已读 30:离线:40撤回
      messageContent: content,
      receiveId: chatDataCenter.chatRoom.customerChannelId,
      senderCode: '',
      senderNickname: chatDataCenter.linkInfo.artificialName,
      sendTime: new Date().getTime(), //发送时间
    });
    setTimeout(() => {
      chatDataCenter.chatRoom.messages.push(messageHotLabel);
      chatDataCenter.scrollToBottom("2");
    }, 400);
  },

  /**
   * 提交意见反馈 type: 问答转人工：'chat'   直接转人工：'session'
   */
  submitToFeedback:function (vue,obj,type,callback) {
    let url = '';
    switch (type) {
      case 'chat':
        url = '/cloud/chatStatus/saveAndUpdateChat';
        break;
      case 'session':
        url = '/cloud/record/saveAndUpdateRecord'
    }
    axios.postCloud(url,obj,function (res) {
      if(res.success){
        if(callback){
          callback(res.data)
        }
      }else {
        vue.$messageBox.Error({message:'提交失败',duration:3000});
      }
    });
  },

  /*
   * 获取微信配置项
   * */

  fetchWeiXinConfig: function (url,thirdId, callback) {
    console.log('=============',thirdId,url)
    axios.postCloud(
      "/cloud/wechat/getSign",
      { url, type:common.getBrowserType(), robotId: chatDataCenter.robotInfo.bindId },
      (response) => {
        console.log(response.data.data);
        callback(
          response.data.data ? response.data.data.openId : "",
          response.data.data ? response.data.data.nickname : ""
        );
        wx.config({
          debug: false, //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: response.data.data.appId, // 必填，公众号的唯一标识
          timestamp: response.data.data.timestamp, /// 必填，生成签名的时间戳
          nonceStr: response.data.data.nonceStr, // 必填，生成签名的随机串
          signature: response.data.data.signature, // 必填，签名
          jsApiList: [
            "startRecord", // 录音开始api
            "stopRecord", // 录音结束api
            "onVoiceRecordEnd", // 超过一分钟自动停止api
            "translateVoice", // 翻译api
            "uploadVoice", // 上传音频api
            "updateTimelineShareData",
          ], // 必填，需要使用的JS接口列表
          openTagList:['wx-open-launch-weapp']
        });
        wx.error(function (res) {
          console.log(res, "---------wxJssdk config 失败");
          chatDataCenter.wxJssdk = false
        });
        wx.ready(function () {
          // //需在用户可能点击分享按钮前就先调用
          // wx.updateTimelineShareData({
          //   title: chatDataCenter.linkInfo.name, // 分享标题
          //   link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //   imgUrl: $config.fileUrl + chatDataCenter.linkInfo.windowLogo, // 分享图标
          //   success: function () {
          //     // 设置成功
          //   },
          // });
          // wx.updateAppMessageShareData({
          //   desc: "", // 分享描述
          //   title: chatDataCenter.linkInfo.name, // 分享标题
          //   link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //   imgUrl: $config.fileUrl + chatDataCenter.linkInfo.windowLogo, // 分享图标
          //   success: function () {
          //     // 设置成功
          //   },
          // });
        });
      }
    );
  },

  /**
   *【web端】侧边栏-标签
   */
  getSidebarTagList: function (robotId) {
    axios.getCloud('/cloud/robot/siteTag/listWeb', { robotId: chatDataCenter.robotInfo.bindId }, response => {
      console.log(response)
      if (response.success){
        chatDataCenter.sidebarLabel = response.data.data;
        chatDataCenter.getSidebarTagQuestionList(response.data.data[0].id);
      }
    })
  },

  /**
   *【web端】侧边栏-标签问题
   */
  getSidebarTagQuestionList: function (tagId) {
    axios.getCloud('/cloud/robot/siteTagQuestion/listWeb', { tagId: tagId }, response => {
      console.log(response)
      if (response.success) {
        chatDataCenter.sidebarProblem = response.data.data;
      }
    })
  },
  /* 获取快捷入口 */
  getQuickEntryList:function () {
    axios.postCloud(
      "/cloud/robot/quickEntry/listWeb",
      {robotId: chatDataCenter.robotInfo.bindId,userType:chatDataCenter.customParams.otherParams.USER_TYPE ? chatDataCenter.customParams.otherParams.USER_TYPE : ''},
      function (res) {
        chatDataCenter.quickEntryList = res.data.data;
      }
    );
  },
  /* 获取底部标签 */
  getBottomList:function () {
    axios.postCloud(
      "/cloud/robot/bottomLabel/listWeb",
      { robotId: chatDataCenter.robotInfo.bindId,userType:chatDataCenter.customParams.otherParams.USER_TYPE ? chatDataCenter.customParams.otherParams.USER_TYPE : '',labelId:chatDataCenter.bottomLabelId},
      function (res) {
        chatDataCenter.bottomLabel = res.data.data
      }
    );
  }
};

export default chatDataCenter;
